{
    "SchedulereportLabel": "Agende este relatório:",
    "SchedulereportNotscheduledOptionLabel": "[Não agendado]",
    "SchedulereportOnceOptionLabel": "Uma vez",
    "SchedulereportHourlyOptionLabel": "De hora em hora",
    "SchedulereportDailyOptionLabel": "Diário",
    "SchedulereportWeeklyOptionLabel": "Semanalmente",
    "SchedulereportMonthlyOptionLabel": "Por mês",
    "SchedulereportResetButtonLabel": "Redefinir",
    "SchedulereportPromptReset": "Tem certeza de que deseja redefinir a programação?",
    "SchedulereportPromptButtonConfirmLabel": "confirme",
    "SchedulereportPromptButtonCancelLabel": "Cancelar",
    "ReportScheduling_SectionHeader": "Agendamento de relatórios",
    "NAME": "ReportScheduling"
}